export default function ErrorBanner({ children }) {
  return (
    <div
      className="fixed top-4 left-1/2 z-50 max-w-[95vw] max-h-[80vh] -translate-x-1/2 rounded-lg border border-red-300/60 dark:border-red-700/60
                 bg-red-800 dark:bg-red-200 text-white/90 dark:text-zinc-900/90 shadow-lg flex items-center gap-3 px-4 py-3 overflow-auto
                 text-xs sm:text-sm"
      role="alert"
      aria-live="assertive"
    >
      {children}
    </div>
  );
}
